import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { createStatisticModel, resetStore } from '@pages/preview/store/slice';
import { selectStatisticModel } from '@pages/preview/store/selectors';
import { DayOrdersStatistics } from '@api/shipping-data/types/DayOrdersStatistics';
import { AppPage } from 'components/app-page/AppPage';
import { DateProgressCard } from 'components/date-progress-card/DateProgressCard';
import CardsArea from '@pages/preview/cards-area/CardsArea';
import useIsSmallScreen from '@hooks/element-size-hooks/useIsSmallScreen';
import { useLazyDayOrdersStatisticsSummaryQuery, useResetDayOrdersStatisticsSummaryMutation } from '@api/shipping-data/api';



export const Preview = () => {

	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const statisticModel = useSelector(selectStatisticModel);
	const dispatch = useDispatch();
	const runCreateStatisticModel = (statistic: DayOrdersStatistics) => dispatch(createStatisticModel(statistic));
	const runResetStore = () => dispatch(resetStore());

	const isSmallScreen = useIsSmallScreen();
	const [ getStatisticsSummary, { data, isLoading, isError, isSuccess } ] = useLazyDayOrdersStatisticsSummaryQuery({
		pollingInterval: 60000,
		skipPollingIfUnfocused: true,
	});
	const [ resetDayOrdersStatisticsSummary ] = useResetDayOrdersStatisticsSummaryMutation();


	useEffect(() => {
		return () => {
			runResetStore()
		}
	}, []);

	
	useEffect(() => {
		if (dateWithoutTime) {
			getStatisticsSummary(dateWithoutTime, true);
		}
	}, [ dateWithoutTime ]);

	
	useEffect(() => {
		if (isSuccess && data) {
			runCreateStatisticModel(data);
		}
	}, [ isSuccess, data ]);


	const resetAllApi = useCallback(() => {
		resetDayOrdersStatisticsSummary();
	},[]);

	
	return (
		<AppPage
			isError={isError || (isSuccess && !statisticModel)}
			isLoading={isLoading}
			className='preview-page'
			pageLabel='Přehled'
			resetPageApi={resetAllApi}
		>
			<div className='preview-content'>
				
				<DateProgressCard deliveredPercent={data && data.totalDeliveredDeliveriesPct ? data.totalDeliveredDeliveriesPct : 0} />

				{statisticModel &&
					<CardsArea statisticModel={statisticModel} />}

				{!isSmallScreen &&
					<div className='graph-area'>
						<div className='graph-item'></div>
						<div className='graph-item'></div>
					</div>}

			</div>
		
		</AppPage>
	)
}

export default Preview;